import {contains, keys, pick} from 'underscore'
import WFormFieldSetMixin from './w-form-fieldset-mixin'

const AUTOCOMPLETE_VALUES = {on: 'on', off: 'nope'}

const PROPS = {
    /**
     * autocomplete form value.  Defaults to `nope`
     */
    autocomplete: {
        type: [String],
        default: AUTOCOMPLETE_VALUES.off,
        validator: (val) => contains(AUTOCOMPLETE_VALUES, val)
    },
    /**
     * Sets form to readonly.  This disables the fieldset
     */
    readonly: {
        type: Boolean,
        default: false
    },
    /**
     * Set to true to remove padding
     */
    dense: {
        type: Boolean,
        default: false
    }
}

export const VALID_EVENT = 'valid'

/**
 * @mixin
 */
export default {
    mixins: [WFormFieldSetMixin],
    props: PROPS,
    data: () => ({
        formValid: false,
    }),
    computed: {
        wFormProps () {
            const vm = this
            const propKeys = keys(PROPS)

            return pick(vm, propKeys)
        },
        wFormEvents () {
            return {
                [VALID_EVENT]: this.handleValid
            }
        }
    },
    methods: {
        handleValid (valid = false) {
            this.formValid = valid
            /**
             * Emit valid event
             * @event submit
             * @type {boolean}
             */
            this.$emit(VALID_EVENT, valid)
        }
    }
}
